export default {
  // 患者性别
  gender: [
    { label: '男', value: '0' },
    { label: '女', value: '1' },
    // { label: '保密', value: '2' },
  ],
  // 患者性别
  genderDict: [
    { label: '男', value: '0' },
    { label: '女', value: '1' },
    // { label: '未知', value: '2' },
  ],
  registerMode: [
    { label: '企微注册', value: 'add_workwechat' },
    { label: '直接注册', value: 'direct' },
  ],
  // 患者状态
  patientStatus: [
    // { label: '待审核', value: 0 },
    // { label: '待授权', value: 1 },
    { label: '待建档', value: 1 },
    { label: '待完善', value: 2 },
    { label: '已完善', value: 3 },
  ],
  // 医院等级
  gradeList: [
    { value: 1, label: '一级医院' },
    { value: 2, label: '二级医院' },
    { value: 3, label: '三级医院' },
    { value: 4, label: '未定级' },
  ],
  // 医院等次
  hospitalClass: [
    { value: 1, label: '甲等' },
    { value: 2, label: '乙等' },
    { value: 3, label: '丙等' },
    { value: 4, label: '特等' },
  ],

  // 区域类别
  typeList: [
    {
      label: '国',
      value: 0,
    },
    {
      label: '省',
      value: 1,
    },
    {
      label: '市',
      value: 2,
    },
    {
      label: '区',
      value: 3,
    },
  ],
  // 菜单级别
  menuLevel: [
    {
      label: '一级菜单',
      value: 1,
    },
    {
      label: '二级菜单',
      value: 2,
    },
    {
      label: '按钮',
      value: 3,
    },
  ],
  // 医学影像类型
  imageType: [
    { label: 'CT', value: 1 },
    { label: 'X光', value: 2 },
    { label: '超声', value: 3 },
    { label: 'MRI', value: 4 },
    { label: 'PET-CT', value: 5 },
    { label: '其他', value: 6 },
  ],
  tumorMarker: [
    { value: '1', label: '甲胎蛋白(AFP)', code: 'AFP', referenceItem: '0～15', unit: 'ng/ml' },
    { value: '2', label: '癌胚抗原(CEA)', code: 'CEA', referenceItem: '0～5', unit: 'ng/ml' },
    { value: '3', label: '癌抗原50(CA50)', code: 'CA50', referenceItem: '0~20', unit: 'U/ml' },
    {
      value: '4',
      label: '癌抗原125(CA125)',
      code: 'CA125',
      referenceItem: '0.1～35',
      unit: 'U/ml',
    },
    {
      value: '5',
      label: '癌抗原153(CA15-3)',
      code: 'CA15-3',
      referenceItem: '0.1～25',
      unit: 'U/ml',
    },
    {
      value: '6',
      label: '癌抗原199(CA19-9)',
      code: 'CA19-9',
      referenceItem: '0.1～27',
      unit: 'U/ml',
    },
    {
      value: '7',
      label: '癌抗原724(CA72-4)',
      code: 'CA72-4',
      referenceItem: '0.1～7',
      unit: 'U/ml',
    },
    { value: '8', label: '癌抗原242(CA242)', code: 'CA242', referenceItem: '0～17', unit: 'U/ml' },
    {
      value: '9',
      label: '细胞角蛋白 211(CYFRA 21-1)',
      code: 'CYFRA 21-1',
      referenceItem: '0.10～4',
      unit: 'ng/ml',
    },
    {
      value: '10',
      label: '神经元特异性烯醇化酶，NSE',
      code: 'NSE',
      referenceItem: '0～16',
      unit: 'ng/ml',
    },
    {
      value: '11',
      label: '鳞状细胞癌抗原(SCC)',
      code: 'SCC',
      referenceItem: '< 1.5 ',
      unit: 'mg/L',
    },
    {
      value: '12',
      label: '总前列腺特异性抗原(TPSA)',
      code: 'TPSA',
      referenceItem: '0.01～4.0',
      unit: 'ng/ml',
    },
    {
      value: '13',
      label: '游离前列腺特异性抗原(FPSA)',
      code: 'FPSA',
      referenceItem: '0.01～2.0 FPSA/TPSA：> 0.15',
      unit: 'ng/ml',
    },
    {
      value: '14',
      label: '血清铁蛋白(SF)',
      code: 'SF',
      referenceItem: '男性：30～400 女性：13～150',
      unit: 'ng/ml',
    },
    {
      value: '15',
      label: '胃泌素前体释放肽(PROGRP)',
      code: 'PROGRP',
      referenceItem: '4～6',
      unit: 'pg/ml',
    },
  ],
  doctorTag: [
    {
      label: 'A类专家',
      value: '1',
    },
    {
      label: 'B类专家',
      value: '2',
    },
    {
      label: 'C类专家',
      value: '3',
    },
  ],
  // 患者档案创建方式
  patientFileType: [
    { label: '免授权方式', value: 'normal' },
    { label: '患者授权方式', value: 'patient_auth' },
    { label: '医院授权方式', value: 'hosp_auth' },
  ],
  activityStatus: [
    {
      label: '未开始',
      value: 'un_start',
    },
    {
      label: '进行中',
      value: 'in_progress',
    },
    {
      label: '已结束',
      value: 'finished',
    },
  ],
  nodeTypeSelect: [
    {
      label: '用药',
      value: 'DRUG_RECORD',
    },
    {
      label: '手术',
      value: 'SURGICAL_RECORD',
    },
    {
      label: '放疗',
      value: 'TREATMENT_RADIOTHERAPY',
    },
    {
      label: '其他',
      value: 'TREATMENT_OTHER_INFORMATION',
    },
  ],
  timelineOtherSelect: [
    {
      label: '诊断',
      value: 'DIAGNOSIS',
    },
    {
      label: 'MDT',
      value: 'MDT_CONCLUSION',
    },
    {
      label: '其他',
      value: 'OTHER_INFORMATION',
    },
  ],
  /** 点评记录 - 评论模块 */
  commentModule: [
    {
      label: '病例详情',
      value: 'medicalRecord',
    },
    {
      label: '质控情况',
      value: 'patientScore',
    },
  ],
  /** 病例更新及点评记录 - 更新模块 */
  updateModule: [
    { value: 'zh_patient', label: '基本信息' },
    { value: 'zh_medical_record', label: '入院记录' },
    { value: 'zh_hospital_discharge_records', label: '出院记录' },
    { value: 'zh_image_report', label: '影像报告' },
    { value: 'zh_surgical_record', label: '手术记录' },
    { value: 'zh_pathology_report', label: '病理报告' },
    { value: 'zh_inspection_report', label: '检验报告' },
    { value: 'zh_genetic_testing', label: '基因检测' },
    { value: 'zh_drug_records', label: '用药记录' },
    { value: 'zh_patient_mdt_issue', label: 'MDT议题' },
    { value: 'zh_mdt_compariso_chart', label: '对比图片' },
    { value: 'zh_mdt_correlation_chart', label: '趋势图' },
    { value: 'zh_other_information', label: '其他' },
  ],
  mdtIssueType: [
    {
      label: '投票型议题',
      value: 'vote',
    },
    {
      label: '讨论型议题',
      value: 'discuss',
    },
  ],
  /** 图片识别状态 */
  imageRecogniteStatus: [
    { value: 'notStarted', label: '未开始', color: 'default' },
    { value: 'parsing', label: '识别中', color: 'processing' },
    { value: 'completed', label: '已结束', color: 'success' },
    { value: 'fail', label: '识别失败', color: 'error' },
  ],
  /** 任务类型 */
  imageRecogniteType: [
    { value: 'multi', label: '多模块', color: 'default' },
    { value: 'single', label: '单模块', color: 'processing' },
  ],
  // 智能识别图片类型修改
  reportTypeEnum: [
    {
      value: 'medicalRecord',
      label: '入院记录',
    },
    {
      value: 'hospitalDischargeRecord',
      label: '出院记录',
    },
    {
      value: 'imageReport',
      label: '影像报告',
    },
    {
      value: 'surgicalRecord',
      label: '手术记录',
    },
    {
      value: 'pathologyReport',
      label: '病理报告',
    },
    {
      value: 'inspectionReport',
      label: '检验报告',
    },
    {
      value: 'geneticTesting',
      label: '基因检测',
    },
    {
      value: 'drugRecord',
      label: '用药记录',
    },
    {
      value: 'otherInformation',
      label: '其他',
    },
    {
      value: 'admission24hDischargeRecord',
      label: '24h出入院记录',
    },
    {
      value: 'admissionProgressRecord',
      label: '住院病程记录',
    },
    {
      value: 'outpatientRecord',
      label: '门诊记录',
    },
    {
      value: 'radiotherapyRecord',
      label: '放疗记录',
    },
  ],
  // 时间选项（每15分钟一个选项）
  timeOptions: [
    { label: '00:00', value: '00:00:00' },
    { label: '00:15', value: '00:15:00' },
    { label: '00:30', value: '00:30:00' },
    { label: '00:45', value: '00:45:00' },
    { label: '01:00', value: '01:00:00' },
    { label: '01:15', value: '01:15:00' },
    { label: '01:30', value: '01:30:00' },
    { label: '01:45', value: '01:45:00' },
    { label: '02:00', value: '02:00:00' },
    { label: '02:15', value: '02:15:00' },
    { label: '02:30', value: '02:30:00' },
    { label: '02:45', value: '02:45:00' },
    { label: '03:00', value: '03:00:00' },
    { label: '03:15', value: '03:15:00' },
    { label: '03:30', value: '03:30:00' },
    { label: '03:45', value: '03:45:00' },
    { label: '04:00', value: '04:00:00' },
    { label: '04:15', value: '04:15:00' },
    { label: '04:30', value: '04:30:00' },
    { label: '04:45', value: '04:45:00' },
    { label: '05:00', value: '05:00:00' },
    { label: '05:15', value: '05:15:00' },
    { label: '05:30', value: '05:30:00' },
    { label: '05:45', value: '05:45:00' },
    { label: '06:00', value: '06:00:00' },
    { label: '06:15', value: '06:15:00' },
    { label: '06:30', value: '06:30:00' },
    { label: '06:45', value: '06:45:00' },
    { label: '07:00', value: '07:00:00' },
    { label: '07:15', value: '07:15:00' },
    { label: '07:30', value: '07:30:00' },
    { label: '07:45', value: '07:45:00' },
    { label: '08:00', value: '08:00:00' },
    { label: '08:15', value: '08:15:00' },
    { label: '08:30', value: '08:30:00' },
    { label: '08:45', value: '08:45:00' },
    { label: '09:00', value: '09:00:00' },
    { label: '09:15', value: '09:15:00' },
    { label: '09:30', value: '09:30:00' },
    { label: '09:45', value: '09:45:00' },
    { label: '10:00', value: '10:00:00' },
    { label: '10:15', value: '10:15:00' },
    { label: '10:30', value: '10:30:00' },
    { label: '10:45', value: '10:45:00' },
    { label: '11:00', value: '11:00:00' },
    { label: '11:15', value: '11:15:00' },
    { label: '11:30', value: '11:30:00' },
    { label: '11:45', value: '11:45:00' },
    { label: '12:00', value: '12:00:00' },
    { label: '12:15', value: '12:15:00' },
    { label: '12:30', value: '12:30:00' },
    { label: '12:45', value: '12:45:00' },
    { label: '13:00', value: '13:00:00' },
    { label: '13:15', value: '13:15:00' },
    { label: '13:30', value: '13:30:00' },
    { label: '13:45', value: '13:45:00' },
    { label: '14:00', value: '14:00:00' },
    { label: '14:15', value: '14:15:00' },
    { label: '14:30', value: '14:30:00' },
    { label: '14:45', value: '14:45:00' },
    { label: '15:00', value: '15:00:00' },
    { label: '15:15', value: '15:15:00' },
    { label: '15:30', value: '15:30:00' },
    { label: '15:45', value: '15:45:00' },
    { label: '16:00', value: '16:00:00' },
    { label: '16:15', value: '16:15:00' },
    { label: '16:30', value: '16:30:00' },
    { label: '16:45', value: '16:45:00' },
    { label: '17:00', value: '17:00:00' },
    { label: '17:15', value: '17:15:00' },
    { label: '17:30', value: '17:30:00' },
    { label: '17:45', value: '17:45:00' },
    { label: '18:00', value: '18:00:00' },
    { label: '18:15', value: '18:15:00' },
    { label: '18:30', value: '18:30:00' },
    { label: '18:45', value: '18:45:00' },
    { label: '19:00', value: '19:00:00' },
    { label: '19:15', value: '19:15:00' },
    { label: '19:30', value: '19:30:00' },
    { label: '19:45', value: '19:45:00' },
    { label: '20:00', value: '20:00:00' },
    { label: '20:15', value: '20:15:00' },
    { label: '20:30', value: '20:30:00' },
    { label: '20:45', value: '20:45:00' },
    { label: '21:00', value: '21:00:00' },
    { label: '21:15', value: '21:15:00' },
    { label: '21:30', value: '21:30:00' },
    { label: '21:45', value: '21:45:00' },
    { label: '22:00', value: '22:00:00' },
    { label: '22:15', value: '22:15:00' },
    { label: '22:30', value: '22:30:00' },
    { label: '22:45', value: '22:45:00' },
    { label: '23:00', value: '23:00:00' },
    { label: '23:15', value: '23:15:00' },
    { label: '23:30', value: '23:30:00' },
    { label: '23:45', value: '23:45:00' },
  ],
  // 会议时长选项
  durationOptions: [
    { label: '15 分钟', value: '15' },
    { label: '30 分钟', value: '30' },
    { label: '45 分钟', value: '45' },
    { label: '1 小时', value: '60' },
    { label: '1.5 小时', value: '90' },
    { label: '2 小时', value: '120' },
    { label: '2.5 小时', value: '150' },
    { label: '3 小时', value: '180' },
    { label: '4 小时', value: '240' },
    { label: '5 小时', value: '300' },
    { label: '选择结束时间', value: 'custom' },
  ],
};
